import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";

import "../../../App.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import Styles from "./cancelorder.module.css";

import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import AddService from "./addService";
import swal from "sweetalert";

function Products() {
    const Navigate = useNavigate();
    const [tableLoad, setTableLoad] = useState(true);
    const [params, setparams] = useSearchParams();
    let [loading, setLoading] = useState(true);
    const [Navactive, setNavactive] = useState("1");
    const [mobile, setMobile] = useState(null);
    const [pageCount, setpageCount] = useState(1);
    const [orders, setOrders] = useState([]);
    const [showPaginate, setShowPagiate] = useState(true);
    const [forcePage, setForcePage] = useState(1);
    const [editable, setEditable] = useState(false);
    const [modal, setModal] = useState(false);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const getorders = (page, active) => {
        setTableLoad(true);
        Services.getTransportServices("GET", null, token, active, page, mobile)
            .then((res) => {
                console.log(res);
                setLoading(false);
                // setTabloader(false);
                setTableLoad(false);

                if (res.Status === 1) {
                    setOrders(res.TransportServices);
                    /*  setpageCount(res?.Pagination?.totalPages);
                    console.log(res?.Pagination?.totalPages);
                    if (res?.Pagination?.totalPages == 0) {
                        console.log("Inside");
                        setShowPagiate(false);
                    } */
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setNavactive(params.get("tab"));
            getorders(params.get("page"), params.get("tab"));
            if (params.get("page")) {
                setpageCount(Number(params.get("page")));
                setForcePage(Number(params.get("page") - 1));

                // console.log(typeof params.get("page"));
            }
        }, 1000);
    }, [mobile]);
    const Idformatter = (cell, cellcontent, index, formatExtraData) => {
        return (
            <div>
                <p className={dashboardclasses["idformatter"]}>{cell}</p>
            </div>
        );
    };

    const priceFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div className={dashboardclasses["price-wrapper"]}>
                <p>₹ {cell}</p>
            </div>
        );
    };
    const deleteHandler = (ID) => {
        swal(`Are You sure you want to Delete?`, {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                    className: Styles["rejected"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    Services.DeleteTransport("DELETE", null, token, ID)
                        .then((res) => {
                            setLoading(true);
                            if (res.Status === 1) {
                                setparams({ page: 1, tab: navactivehandler });
                                getorders(1, Navactive);

                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const ActionFormatter = (cell, cellcontent) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setEditable(cellcontent);
                        setModal(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
                <button
                    onClick={() => {
                        deleteHandler(cellcontent?.subServiceId);
                    }}
                    id={cellcontent._id}>
                    <MdDelete size={18} />
                </button>
            </div>
        );
    };
    let columns = [
        {
            dataField: "subServiceName",
            text: "SUB SERVICE NAME",
            sort: false,

            // cell: (row, index) => index + 1,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "subServiceCaption",
            text: "SUB SERVICE CAPTION",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "additional_price_per_km",
            text: "ADDL.PRICE PER KM",
            sort: false,

            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "additional_price_per_minute",
            text: "ADDL.PRICE PER MIN",
            sort: false,
            formatter: priceFormatter,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "base_fare_amount",
            text: "BASE FARE AMOUNT",
            sort: false,
            formatter: priceFormatter,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "base_fare_minute",
            text: "BASE FARE PER MIN",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "base_fare_km",
            text: "BASE FARE KM",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "night_charges",
            text: "NIGHT CHARGES",
            sort: false,
            formatter: (cell) => `${cell} %`,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "minimum_fare",
            text: "MINIMUM FARE",
            sort: false,
            formatter: priceFormatter,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
        /*   {
            dataField: "grand_total",
            text: "RIDE FARE",
            sort: false,
            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "payment_method",
            text: "PAYMENT",
            sort: false,
            formatter: (cell) => (cell == 1 ? "CASH" : "WALLET"),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        }, */
    ];

    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setForcePage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);
        setparams({ page: selectedObject.selected + 1, tab: Navactive });
        getorders(selectedObject.selected + 1, Navactive);
        setTableLoad(true);
    };

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);

        setparams({ page: 1, tab: status });
        getorders(1, status);
    };

    const emptyDataMessage = () => {
        return "No Data to Display";
    };

    return (
        <>
            {modal && (
                <AddService
                    setmodal={setModal}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={() =>
                        getorders(params.get("page"), params.get("tab"))
                    }
                />
            )}
            <Layout Active={"Transport_services"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                {/*     <div
                                    className={
                                        dashboardclasses["category-form"]
                                    }>
                                    <input
                                    type={"text"}
                                    placeholder="search by Mobile number"
                                        onChange={searchHandler}
                                    />
                                    </div> */}
                                <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <h3>Transport Services</h3>
                                    <button onClick={() => setModal(true)}>
                                        + Add Transport Service
                                    </button>
                                </div>
                                <div
                                    className={
                                        dashboardclasses["orders-navbar"]
                                    }>
                                    <button
                                        id="1"
                                        className={
                                            Navactive == "1" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Share Ride
                                    </button>
                                    <button
                                        id="2"
                                        className={
                                            Navactive == "2" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Offer Ride
                                    </button>

                                    <button
                                        id="3"
                                        className={
                                            Navactive == "3" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Classic Ride
                                    </button>
                                    <button
                                        id="4"
                                        className={
                                            Navactive == "4" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        One way
                                    </button>
                                    <button
                                        id="5"
                                        className={
                                            Navactive == "5" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Round trip
                                    </button>
                                </div>

                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={orders}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            // pagination={pagination}
                                            wrapperClasses="table-responsive"
                                            noDataIndication={emptyDataMessage}
                                        />
                                        {/*  {showPaginate && (
                                            <div
                                                style={{
                                                    justifySelf: "right",
                                                }}>
                                                <ReactPaginate
                                                    pageCount={pageCount}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={
                                                        handlePageChange
                                                    }
                                                    forcePage={forcePage}
                                                    breakClassName={"page-item"}
                                                    breakLinkClassName={
                                                        "page-link"
                                                    }
                                                    containerClassName={
                                                        "pagination"
                                                    }
                                                    pageClassName={"page-item"}
                                                    pageLinkClassName={
                                                        "page-link"
                                                    }
                                                    previousClassName={
                                                        "page-item"
                                                    }
                                                    previousLinkClassName={
                                                        "page-link"
                                                    }
                                                    nextClassName={"page-item"}
                                                    nextLinkClassName={
                                                        "page-link"
                                                    }
                                                    activeClassName={"active"}
                                                />
                                            </div>
                                        )} */}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
